import Vue from "vue";
import {Month} from "../enums/month";
import DurationAndTimeHelper from "../helpers/durationAndTimeHelper";

export default Vue.extend({
  methods: {
    daysOptions(month) {
      if (month === Month.february) {
        return DurationAndTimeHelper.dayOptions.slice(0, 29)
      } else if ([Month.april, Month.june, Month.september, Month.november].includes(month)) {
        return DurationAndTimeHelper.dayOptions.slice(0, 30)
      } else {
        return DurationAndTimeHelper.dayOptions
      }
    }
  },
});